import _ from 'lodash';

export const getCurrencyUnitList = currencies => {
  const currencyUnitInfo = {};
  currencies.map(({ currency, currency_symbol = "" }) => {
    currencyUnitInfo[currency] = currency_symbol || "";
  });
  return currencyUnitInfo;
};
